module.exports = __webpack_public_path__ + "img/contents_bus@2x.4d7b710f.png";